module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Document-349e2b13f61143fd53513de4bc1f1150.svg";